import React from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import { styled } from "@mui/system";

const Image = styled("img")`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

const ComingSoon = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "background.default",
            textAlign: "center",
          }}
        >
          <Image
            src="https://source.unsplash.com/random?robot"
            alt="AI Chatbot"
          />
          <Typography variant="h3" gutterBottom>
            🤖 Coming Soon 🤖<br></br>My AI Replacement
          </Typography>
          <Typography variant="h5" gutterBottom>
            Is it a bird? Is it a plane? No, it's SuperAI! Here to save the day and replace me in a cool and witty way.
          </Typography>
          <Typography variant="body1" gutterBottom>
            Our team of caffeinated coding wizards is working around the clock to perfect an AI chatbot so smart, it's almost scary. And yes, it's been programmed to laugh at all your jokes. Stay tuned for the grand unveiling!
          </Typography>
          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              href="#"
              onClick={() => alert("Sign up for updates coming soon!")}
            >
              Be the First to Know
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ComingSoon;
